import { SITE_LANGUAGE_CODES } from './siteLanguages';

const SUPPORTED = new Set(SITE_LANGUAGE_CODES);

// Older Android and Java report legacy codes; NowTarot only uses "fil" and "id".
const ALIASES = { tl: 'fil', in: 'id' };

export function normalizeLanguageTag(tag) {
  const base = String(tag || '').trim().toLowerCase().split(/[-_]/)[0];
  return ALIASES[base] || base;
}

// Reads the browser's ordered language list and returns the first one NowTarot
// has a page for. English anywhere above it wins, so someone who lists
// English first and Spanish second keeps English. Returns 'en' when nothing
// matches, and during prerender, so the saved HTML stays English.
export function browserSiteLanguage(languages) {
  let list = languages;
  if (!list) {
    if (typeof navigator === 'undefined' || navigator.userAgent === 'ReactSnap') return 'en';
    list = navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language];
  }
  for (const tag of list) {
    const code = normalizeLanguageTag(tag);
    if (code === 'en') return 'en';
    if (SUPPORTED.has(code)) return code;
  }
  return 'en';
}
